var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M8 5.14v14l11-7-11-7z","fill":"#fff"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }